// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2xPme","actionsCol":"EnrolledClinics_actionsCol__1QV-O"};